import type { TOC } from '@ember/component/template-only';

import DataManagerConnectedDatasetsViewComponent from 'webapp/components/data-manager/connected/datasets/view';

interface Args {
	controller: { model: string | null };
}

const DatamanagerConnectedDatasetsViewRouteTemplate: TOC<Args> = <template>
	<DataManagerConnectedDatasetsViewComponent @model={{@controller.model}} />
</template>;

export default DatamanagerConnectedDatasetsViewRouteTemplate;
